import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { AppLayout } from "@/components/layout/AppLayout";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import LoginPage from "@/pages/Login";
import BigBoardPage from "@/pages/BigBoard";
import OpportunitiesPage from "@/pages/Opportunities";
import DeepDivePage from "@/pages/DeepDive";
import RevenuePage from "@/pages/Revenue";
import VenturesPage from "@/pages/Ventures";
import MilestonesPage from "@/pages/Milestones";
import ProfilePage from "@/pages/Profile";
import SettingsPage from "@/pages/Settings";
import AchievementsPage from "@/pages/Achievements";
import PainAnalyticsPage from "@/pages/PainAnalytics";

export default function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <RequireAuth>
                  <ErrorBoundary>
                    <AppLayout />
                  </ErrorBoundary>
                </RequireAuth>
              }
            >
              <Route path="/" element={<BigBoardPage />} />
              <Route path="/opportunities" element={<OpportunitiesPage />} />
              <Route path="/opportunities/:id" element={<DeepDivePage />} />
              <Route path="/pain-analytics" element={<PainAnalyticsPage />} />
              <Route path="/revenue" element={<RevenuePage />} />
              <Route path="/ventures" element={<VenturesPage />} />
              <Route path="/milestones" element={<MilestonesPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/achievements" element={<AchievementsPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A1A19",
            border: "1px solid #1A2E2C",
            color: "#F2F2F2",
          },
        }}
      />
    </TooltipProvider>
  );
}
